module.exports = __webpack_public_path__ + "static/media/news-img01.d80ec5e7.jpg";